<template>
  <div class="sub-footer" :class="{ 'm-0': subfootershow }">
    <h6 v-if="domainBasedBrand">
      {{
        _T_DB(currentBrand, 'name') + ' ' + _T('© 2022. All rights reserved')
      }}
    </h6>
    <h6 v-else>
      {{ _T('GoOrder © 2020. All rights reserved') }}
    </h6>
    <ul class="sub-footer-list">
      <li>
        <router-link
          :to="{ name: 'terms' }"
          v-if="
            all_static_pages_by_slug_search(CONST.TERMS_AND_CONDITIONS_SLUG)
          "
        >
          {{ _T('Terms & Conditions') }}
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'privacy' }"
          v-if="all_static_pages_by_slug_search(CONST.PRIVACY_POLICY_SLUG)"
        >
          {{ _T('Privacy Policy') }}
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{ name: '' }">{{ _T('Cookies') }}</router-link>
      </li> -->
    </ul>
    <div class="sub-footer-image">
      <!-- <svg class="mr-1" width="172" height="57" fill="none">
        <use xlink:href="#playStoreBadge" />
      </svg> -->
      <a href="https://www.dimsapp.com">
      <!-- <div class="dimsapps"></div> -->
      <img src="/images/dimsapps.png" class="dimsapp-img" />
      </a>
      <!-- <svg class="mr-1" width="172" height="57" fill="none">
        <use xlink:href="#appStoreBadge" />
      </svg> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      subfooter: ['404'],
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'domainBasedBrand',
      'currentBrand',
      'all_static_pages_by_slug_search',
    ]),
    subfootershow() {
      if (
        this.$route.matched.some(({ name }) => this.subfooter.includes(name))
      ) {
        return true
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
.dimsapps {
  height: $px97;
  width: $px168;
  background: url('/images/dimsapps.png');
  background-size: cover;
}
.dimsapp-img {
  height: $px97;
  width: $px168;
}
</style>